import { DoctorCardsList, doctorsStore } from 'features/doctors';
import {
	IDay,
	ScheduleCalendar,
	ScheduleFeedHeader,
	ScheduleFeedList,
} from 'features/schedule';
import { Fragment, useCallback, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { clinicsStore } from 'entities/clinics';
import clsx from 'clsx';
import { timeslotsStore } from 'entities/timeslots';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

export const DoctorsSchedule = observer(() => {
	const [selectedDay, setSelectedDay] = useState<IDay | null>(null);
	const [calendarIsOpen, setCalendarOpened] = useState(false);
  const { id } = useParams();

	useEffect(() => {
		clinicsStore.fetchClinics();
	}, []);

  useEffect(() => {
    if (id&&doctorsStore.activeDoctor) {
		  clinicsStore.fetchClinics();
    }
    // eslint-disable-next-line
  }, [id, doctorsStore.activeDoctor])

	const handleOpenCalendar = () => {
		setCalendarOpened(!calendarIsOpen);
	};

	const closeCalenar = () => {
		setCalendarOpened(false);
	};

	const selectDay = useCallback((day: IDay) => {
		setSelectedDay(day);
	}, []);

	const scheduleFeedClass = clsx(styles['schedule-feed-list'], {
		[styles['schedule-feed-list--invisible']]: calendarIsOpen,
	});

	const doctorsListClass = clsx(styles['doctors-list'], {
		[styles['doctors-list--invisible']]: calendarIsOpen,
	});

	return (
		<Fragment>
			<ScheduleFeedHeader
				selectedDay={selectedDay}
				setOpenCalendar={handleOpenCalendar}
				isOpenCalendar={calendarIsOpen}
			/>

			<div className={scheduleFeedClass}>
				<ScheduleFeedList selectDay={selectDay} />
			</div>

			{timeslotsStore.monthSlots.length > 0 && (
				<ScheduleCalendar
					isOpen={calendarIsOpen}
					close={closeCalenar}
					day={selectedDay?.date}
					dateCalendarStart={new Date(timeslotsStore.monthSlots[0].date)}
				/>
			)}

			<div className={doctorsListClass}>
				<DoctorCardsList />
			</div>
		</Fragment>
	);
});
